import { SelectField } from "@/shared/components/form/Select";
import { useEffect, useState } from "react";
import { useForm } from "react-hook-form";
import { Button, Col, Row } from "reactstrap";

import { useQuery } from "@apollo/client";
import moment from "moment";
import DatePicker from "react-datepicker";
import { GET_ALL_USER } from "../../../GraphQL/Queries";
import FormField from "./FormField";
import queryString from "query-string";
import { useHistory } from "react-router";
const SearchForm = ({
  setFilterByUsername,
  setToDate,
  setFromDate,
  toDate,
  fromDate,
  filterByAny,
  userID,
  data,
  roles,
  searchResult,
  setFilteredResults,
  filteredAttendance,
  setOnSearch,
  setFilteredAttendance,
  setIsViewResult,
  isViewResult,
  allEmployees,
  setAllEmployees,
  todayCount,
  workingDays,
  LoadWorkingDayData,
  totalData,

  currentPage,
}) => {
  //
  const [defaultSeachType, setDefaultSearchType] = useState("");
  const history = useHistory();
  const {
    handleSubmit,
    control,
    watch,
    reset,
    getValues,
    formState: { errors },
  } = useForm({
    shouldUnregister: false,
    defaultValues: {
      user_id: null,
      // search_type: defaultSeachType,
    },
  });
  const [userId, setUserId] = useState(null);

  const updateURLParams = (params) => {
    const newParams = {
      ...params,
    };
    const queryParams = queryString.stringify(newParams);
    history.push({ search: `?${queryParams}` });
  };

  // get previous date of month fron now start
  const prevDateOfMonth = new Date();
  const month = prevDateOfMonth.getMonth();
  prevDateOfMonth.setMonth(prevDateOfMonth.getMonth() - 1);
  while (prevDateOfMonth.getMonth() === month) {
    prevDateOfMonth.setDate(prevDateOfMonth.getDate() - 1);
  }
  const LoadAllUsers = useQuery(GET_ALL_USER);
  const [lastMonth, setLastmonth] = useState(prevDateOfMonth);
  const searchTypeValue = watch("search_type");

  const userTypeValue = watch("user_id");
  const [isDisabledDate, setIsDisabledDate] = useState(false);

  // last weeek
  const firstDay = new Date();
  const previousweek = new Date(firstDay.getTime() - 7 * 24 * 60 * 60 * 1000);
  useEffect(() => {
    let attendanceArray = LoadAllUsers?.data?.getUser?.map((item) => {
      return {
        value: item.additionalInfo?.user_id,
        label: `${item.name} - (${item?.additionalInfo?.rfid})`,
      };
    });
    attendanceArray?.length &&
      attendanceArray.unshift({ value: null, label: "All" });
    setAllEmployees(attendanceArray);
  }, [LoadAllUsers?.data?.getUser?.length]);
  // const searchBetweenDate = useQuery(SEARCH_ATTENDANCE_BETWEEN_DATE);
  // const searchBetweenDateAndRfid = useQuery(SEARCH_ATTENDANCE_BETWEEN_DATE_AND_RFID);
  useEffect(() => {
    reset({ user_id: "" });
  }, [filterByAny]);

  const searchType = [
    { value: null, label: "None" },
    { value: 1, label: "Weekly" },
    { value: 2, label: "Monthly" },
  ];

  useEffect(() => {
    if (watch("search_type")?.value) {
      setIsDisabledDate(true);
    }
    if (watch("search_type")?.value == null) {
      setIsDisabledDate(false);
    }
  }, [watch("search_type")]);

  const onSubmit = async (value) => {
    history.replace({ search: "" });
    if (!fromDate && !toDate) {
      setFromDate(null);
      setToDate(null);
    }
    if (value?.search_type?.value == 1) {
      const tz = "Asia/Dhaka";

      const todayStr = moment.tz(tz).format("YYYY-MM-DD");

      const last7Str = moment.tz(tz).subtract(7, "days").format("YYYY-MM-DD");
      LoadWorkingDayData?.refetch({
        input: {
          start_date: last7Str,
          end_date: todayStr,
        },
      });
    }
    if (value?.search_type?.value == 2) {
      LoadWorkingDayData?.refetch({
        input: {
          start_date: moment(lastMonth).format("YYYY-MM-DD"),
          end_date: moment(new Date()).format("YYYY-MM-DD"),
        },
      });
    }

    setFilteredAttendance([]);
    if (fromDate && toDate) {
      LoadWorkingDayData?.refetch({
        input: {
          start_date: fromDate,
          end_date: toDate,
        },
      });
    }

    searchResult(
      fromDate,
      toDate,
      value?.user_id?.value,
      Number(value?.search_type?.value)
    );
    setIsViewResult(true);
    const current = getValues();
    setDefaultSearchType(current?.search_type?.value);
    history.replace({ search: "" });
    updateURLParams({
      searchType: current?.search_type?.value,
      fromDate: moment(fromDate).format("YYYY-MM-DD"),
      toDate: moment(toDate).format("YYYY-MM-DD"),
      user_id: value?.user_id?.value,
      page: 1,
      // rfid: rfid,
    });
    // reset(current);
  };

  const onChange = (dates) => {
    const [start, end] = dates;

    setFromDate(start);
    setToDate(end);

    // Filtering logic based on the selected dates
    if (start && end) {
      // Both dates are selected, apply the filter for the range
    } else if (start) {
      // Only the start date is selected, apply the filter for that date onward
    } else {
      // Both dates are cleared, you might want to reset your filters here
    }
  };

  return (
    <Row>
      <Col md={12} className="mx-auto">
        <form
          className="form justify-content-center"
          onSubmit={handleSubmit(onSubmit)}
        >
          {!searchTypeValue ? (
            <Col xs={6} md={3} lg={2} className="mr-3">
              <DatePicker
                dateFormat="dd/MM/yyyy"
                placeholderText="dd/mm/yyyy - dd/mm/yyyy"
                selected={fromDate}
                onChange={onChange}
                startDate={fromDate}
                endDate={toDate}
                selectsRange
              />
            </Col>
          ) : null}

          {roles?.includes("System Admin") ||
          roles?.includes("Human Resource (HR)") ||
          roles?.includes("Head Of Department") ? (
            <Col xs={12} md={6} lg={3} className="me-3">
              <div className="form__form-group">
                <div className="form__form-group-field">
                  <FormField
                    name="user_id"
                    control={control}
                    component={SelectField}
                    options={allEmployees}
                    placeholder="Select user"
                    rules={{ required: "Please Select a User" }}
                  />
                </div>
                {/* Display error message if the required validation fails */}
                {errors.user_id && (
                  <p style={{ color: "red", fontSize: "12px" }}>
                    {errors.user_id.message}
                  </p>
                )}
              </div>
            </Col>
          ) : null}

          {(roles?.includes("System Admin") ||
            roles?.includes("Human Resource (HR)") ||
            roles?.includes("Head Of Department")) &&
          !fromDate ? (
            <Col xs={12} md={6} lg={2}>
              <div className="form__form-group mr-3">
                <div className="form__form-group-field">
                  <FormField
                    name="search_type"
                    control={control}
                    component={SelectField}
                    options={searchType}
                    placeholder="Weekly/Monthly"
                    rules={{ required: "Search type is required" }}
                  />
                </div>
                {errors.search_type && (
                  <p style={{ color: "red", fontSize: "12px" }}>
                    {errors.search_type.message}
                  </p>
                )}
              </div>
            </Col>
          ) : null}

          <Col xs={12} md={6} lg={4}>
            <div className="form justify-content-center form__form-group">
              <div className="form__form-group-field ">
                <Button
                  className="btn btn-sm py-2"
                  type="submit"
                  // disabled={!searchTypeValue}
                  disabled={
                    userTypeValue?.value === null &&
                    searchTypeValue?.value === null &&
                    !fromDate
                  }
                  // disabled={(!userTypeValue && !searchTypeValue) || !fromDate}
                >
                  {" "}
                  Filter{" "}
                </Button>
                <Button
                  // disabled={!isViewResult}
                  className="btn btn-sm"
                  onClick={() => {
                    history.replace({ search: "" });
                    reset({ user_id: "", search_type: "" });
                    setFilterByUsername(null);
                    setIsDisabledDate(false);
                    setIsViewResult(false);
                    setFromDate(null);
                    setToDate(null);
                    setFilteredAttendance([]);
                  }}
                >
                  {" "}
                  Clear{" "}
                </Button>
              </div>
            </div>
          </Col>
        </form>
      </Col>
      <Col md={12}>
        <span className="text-success">
          {isViewResult && filteredAttendance?.total?.total > 0
            ? watch("user_id")?.value
              ? `Attendance: ${filteredAttendance?.total?.total}/${
                  workingDays?.working_days
                } working days, Holiday: ${
                  workingDays?.holidays
                } days, Weekend: ${workingDays?.weekends} days, Total: ${
                  workingDays?.working_days +
                  workingDays?.weekends +
                  workingDays?.holidays
                } days`
              : `Result found ${filteredAttendance?.total?.total} items`
            : null}
        </span>
      </Col>
      <Col md={12}>
        <span className="text-success bold-text">
          {roles?.includes("System Admin") ||
          roles?.includes("Human Resource (HR)") ||
          roles?.includes("Head Of Department")
            ? !isViewResult && todayCount
              ? `Today attendance ${
                  todayCount?.filter((item) => item?.attendance == true)?.length
                } of ${totalData} users.`
              : null
            : null}
        </span>
      </Col>
    </Row>
  );
};

export default SearchForm;
